import { defaultTheme } from "../core/theme/themes";
function deepMerge(target, source) {
    const result = { ...target };
    for (const key in source) {
        if (source.hasOwnProperty(key)) {
            const sourceValue = source[key];
            const targetValue = result[key];
            if (sourceValue &&
                typeof sourceValue === "object" &&
                !Array.isArray(sourceValue) &&
                targetValue &&
                typeof targetValue === "object" &&
                !Array.isArray(targetValue)) {
                result[key] = deepMerge(targetValue, sourceValue);
            }
            else if (sourceValue !== undefined) {
                result[key] = sourceValue;
            }
        }
    }
    return result;
}
export function mergeTheme(partialTheme) {
    if (!partialTheme) {
        return defaultTheme;
    }
    return deepMerge(defaultTheme, partialTheme);
}
function getCssVarName(prefix, category, key) {
    return `--${prefix}-${category}-${key
        .replace(/([A-Z])/g, "-$1")
        .toLowerCase()}`;
}
export function generateCssVariables(theme, prefix = "medos") {
    const vars = [];
    Object.entries(theme.colors).forEach(([key, value]) => {
        vars.push(`${getCssVarName(prefix, "color", key)}: ${value};`);
    });
    Object.entries(theme.typography).forEach(([key, value]) => {
        vars.push(`${getCssVarName(prefix, "typography", key)}: ${value};`);
    });
    Object.entries(theme.spacing).forEach(([key, value]) => {
        vars.push(`${getCssVarName(prefix, "spacing", key)}: ${value};`);
    });
    Object.entries(theme.shadows).forEach(([key, value]) => {
        vars.push(`${getCssVarName(prefix, "shadow", key)}: ${value};`);
    });
    Object.entries(theme.radii).forEach(([key, value]) => {
        vars.push(`${getCssVarName(prefix, "radius", key)}: ${value};`);
    });
    Object.entries(theme.transitions).forEach(([key, value]) => {
        vars.push(`${getCssVarName(prefix, "transition", key)}: ${value};`);
    });
    return vars.join("\n  ");
}
export function generateCssVariablesObject(theme, prefix = "medos") {
    const vars = {};
    Object.entries(theme.colors).forEach(([key, value]) => {
        vars[getCssVarName(prefix, "color", key)] = value;
    });
    Object.entries(theme.typography).forEach(([key, value]) => {
        vars[getCssVarName(prefix, "typography", key)] = value;
    });
    Object.entries(theme.spacing).forEach(([key, value]) => {
        vars[getCssVarName(prefix, "spacing", key)] = value;
    });
    Object.entries(theme.shadows).forEach(([key, value]) => {
        vars[getCssVarName(prefix, "shadow", key)] = value;
    });
    Object.entries(theme.radii).forEach(([key, value]) => {
        vars[getCssVarName(prefix, "radius", key)] = value;
    });
    Object.entries(theme.transitions).forEach(([key, value]) => {
        vars[getCssVarName(prefix, "transition", key)] = value;
    });
    return vars;
}
export function getCssVar(prefix, category, key, fallback) {
    const varName = getCssVarName(prefix, category, key);
    return fallback ? `var(${varName}, ${fallback})` : `var(${varName})`;
}
export function validateTheme(theme) {
    const errors = [];
    if (!theme || typeof theme !== "object") {
        errors.push("Theme must be an object");
        return errors;
    }
    const requiredProps = [
        "colors",
        "typography",
        "spacing",
        "shadows",
        "radii",
        "transitions",
    ];
    requiredProps.forEach((prop) => {
        if (!theme[prop] || typeof theme[prop] !== "object") {
            errors.push(`Theme.${prop} is required and must be an object`);
        }
    });
    return errors;
}
